<template>
  <div style="display: flex; margin: 5px 0;" >
          <vue-country-flag  style="margin-right: -14px;" class="block-inline" v-if="lang" :country='getLanguageFromLabel(lang)' size="small" />
          <span v-if="contents == '0'" class="badge badge-danger">Nascosto</span>
          <span v-else-if="contents == '1'" class="badge badge-success">Pubblicata</span>
          <span v-else-if="contents == '2'" class="badge badge-warning">Bozza</span>
          <span v-else-if="contents == '3'" class="badge badge-warning">Da Validare</span>
          <span v-else-if="contents == '4'" class="badge badge-secondary">Revisione</span>
          <span v-else-if="contents == '5'" class="badge badge-secondary">Da Validare</span>
          <span v-else class="badge badge-dark">Non presente</span>
  </div>
</template>
<script>
    export default {
        name: "StatuseSpan",
        props: ['contents', 'lang'],
        methods: {
          getLanguageFromLabel: function (label) {
                let result = label;
                switch (label) {
                    case "en":
                        result = "gb";
                        break;

                    default:
                        result = label;
                        break;
                }
                return result;
            }
        }
    }; // export
</script>
